import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PATHS } from '../../constants';
import { useSessionContext } from '../../contexts/SessionContext';
import { useAppContext } from '../../hooks';
import { getFullName, getInitials } from '../../utils/User';
import {
  StyledAvatar,
  StyledButton,
  StyledCollapse,
  StyledNavLink,
  UserContainer,
  UserInfoRow,
  UserName,
} from './UserInfo.styles';

interface UserInfoProps {
  isExpanded: boolean;
}

const UserInfo = ({ isExpanded }: UserInfoProps) => {
  const { t } = useTranslation();
  const [userInfoCollapse, setUserInfoCollapse] = useState(false);
  const { me } = useSessionContext();
  const { logout } = useAppContext();

  const initials = getInitials(me?.firstName, me?.lastName);
  const fullName = getFullName(me?.firstName, me?.lastName);

  return (
    <UserContainer>
      <StyledCollapse
        title={
          <UserInfoRow>
            <StyledAvatar text={initials} src={me?.imageUrl} />
            <UserName $isExpanded={isExpanded}>{fullName}</UserName>
          </UserInfoRow>
        }
        onClick={() => setUserInfoCollapse(!userInfoCollapse)}
        open={userInfoCollapse && isExpanded}
        $isExpanded={userInfoCollapse}
      >
        <StyledNavLink to={PATHS.Settings}>{t('profile.settings')}</StyledNavLink>
        <StyledButton onClick={() => void logout()}>{t('profile.logout')}</StyledButton>
      </StyledCollapse>
    </UserContainer>
  );
};

export default UserInfo;
